/* Logger stub that uses the existing Dexie DB from db.ts (fileStorage table). */
import { getUserDB } from './db';

type LogLevel = 'info' | 'warn' | 'error';

function safeStringify(value: unknown): string {
  if (value instanceof Error) {
    return `${value.name}: ${value.message}\n${value.stack ?? ''}`.trim();
  }
  try {
    if (typeof value === 'string') return value;
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}

function joinArgs(args: unknown[]): string {
  return args.map(safeStringify).join(' ');
}

async function persist(level: LogLevel, args: unknown[]): Promise<void> {
  const message = joinArgs(args);
  // Use a default bucket when no user context is available
  const db = getUserDB('default');

  try {
    const filePath = `logs/${Date.now()}_${Math.random()
      .toString(36)
      .slice(2)}.json`;
    const content = JSON.stringify({ level, message, timestamp: Date.now() });
    await db.fileStorage.put({ filePath, content });
  } catch {
    // eslint-disable-next-line no-console
    (console[level] ?? console.log)(message);
  }
}

const logger = {
  info: (...args: unknown[]) => {
    void persist('info', args);
  },
  warn: (...args: unknown[]) => {
    void persist('warn', args);
  },
  error: (...args: unknown[]) => {
    void persist('error', args);
  },
};

export default logger;
